"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function fix$parent(stext) {
    if (stext.indexOf('$parent') > -1) {
        return stext
            .replace(/\$parent\.\$parent\.\$parent\./g, '$parent3.')
            .replace(/\$parent\.\$parent\./g, '$parent2.')
            .replace(/\$parent\./g, '$parent.');
    }
    else {
        return stext;
    }
}
exports.default = fix$parent;
//# sourceMappingURL=fix$parent.js.map